export default __webpack_public_path__ + "static/media/vegetablechips@2x.b3a15ed1.jpg";